export const translations = {
	common: {
		en: async () => import('./translations/en.json'),
		ru: async () => import('./translations/ru.json'),
		uz: async () => import('./translations/uz.json'),
	},
}
export const LANGUAGES = ['ru', 'uz', 'en'] as const
export type Language = (typeof LANGUAGES)[number]
// Each language names itself, so the picker reads the same whatever the panel's language.
export const LANGUAGE_NAMES: Record<Language, string> = {
	ru: 'Русский',
	uz: 'Oʻzbekcha',
	en: 'English',
}
export const FALLBACK_LANGUAGE = 'ru'
export const DEFAULT_LANGUAGE: Language = 'uz'

export type TranslationKeys = Awaited<
	ReturnType<typeof translations.common.ru>
>['default']

type DotPrefix<T extends string> = T extends '' ? '' : `.${T}`

export type DotNotation<T> = (
	T extends object
		? {
				[K in keyof T]: K extends string
					? T[K] extends object
						? `${K}` | `${K}${DotPrefix<DotNotation<T[K]>>}`
						: never
					: never
		  }[keyof T]
		: never
) extends infer D
	? Extract<D, string>
	: never

export type TranslationPaths = DotNotation<TranslationKeys>

export {
	useTranslate,
	type TranslationFunction,
	type TranslationKey,
	type ColumnTranslationFunction,
} from './utils/useTranslate'
export {
	useTranslateInitializer,
	translate,
} from './utils/getTranslationFunction'
